import React from 'react';
import './AddPaymentPorterWizard.css';

// `title` is overridable because the same step answers a differently-worded question elsewhere — the
// Universal API asks which BACKEND SYSTEM a property is reached through, and calling that "PMS" names
// the wrong thing when the system on offer is a CRM or a channel manager.
const WizardPmsStep = ({ marketplaces, selectedMarketplace, onSelect, error, subtitle, onBack, onNext, title = 'Select PMS' }) => (
    <div className="ppw-card">
        <div className="ppw-card-header">
            <h2 className="ppw-card-title">{title}</h2>
            {subtitle && <p className="ppw-card-subtitle">{subtitle}</p>}
        </div>
        <div className="ppw-card-body">
            {error && <span className="ppw-error-msg">{error}</span>}
            <div className="ppw-connector-list">
                {(marketplaces || []).length > 0 ? marketplaces.map(m => (
                    <button
                        key={m.id}
                        className={`ppw-connector-card${selectedMarketplace?.id === m.id ? ' selected' : ''}`}
                        onClick={() => onSelect(m)}
                    >
                        <div className="ppw-connector-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke="#4a6cf7" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="ppw-connector-info">
                            <div className="ppw-connector-name">{m.name}</div>
                            {m.description && <div className="ppw-connector-meta">{m.description}</div>}
                        </div>
                    </button>
                )) : (
                    <div className="ppw-empty-state">
                        <strong>No marketplaces available</strong>
                        No systems are configured. Contact your administrator.
                    </div>
                )}
            </div>
        </div>
        <div className="ppw-footer">
            <button className="ppw-btn-back" onClick={onBack}>← Back</button>
            <button className="ppw-btn-next" onClick={onNext} disabled={!selectedMarketplace}>Next →</button>
        </div>
    </div>
);

export default WizardPmsStep;
